const getNccCategoriesColumnGroups = () => [
  {
    id: 'category',
    name: 'Category',
    hideInSelect: true,
  },
]

export { getNccCategoriesColumnGroups }
